import React, { useCallback } from 'react'
import { AutoComplete, AutoCompleteDataType, AutoCompleteProps } from 'scenes/Dashboard/components/Inputs/Select'
import { AutoCompleteOption } from 'scenes/Dashboard/components/Inputs/Select/AutoComplete/AutoComplete.model'
import { FieldProps, getIn } from 'utils-next/forms'

export type FundingRoundTypeSelectProps = Omit<
  AutoCompleteProps,
  'value' | 'dataType' | 'onCreateOption' | 'onChange'
> &
  FieldProps

export function FundingRoundTypeSelect({
  field: { name, value },
  form: { setFieldValue, errors },
  ...asyncSelectProps
}: FundingRoundTypeSelectProps) {
  const handleChange = useCallback(
    (autoCompleteOption: AutoCompleteOption | '') => {
      if (!autoCompleteOption) {
        setFieldValue(name, '')
        return
      }

      const { value } = autoCompleteOption
      setFieldValue(name, value.name)
    },
    [name, setFieldValue]
  )

  const parsedValue = value ? { value: value.id, display: { label: value } } : ''

  return (
    <AutoComplete
      dataType={AutoCompleteDataType.roundType}
      onChange={handleChange}
      value={parsedValue}
      isClearable
      name={name}
      error={getIn(errors, name)}
      {...asyncSelectProps}
    />
  )
}
